export default {
    blue: {
        primary: '#36b8e1', // item 2 - #ff5406 ; item 1 - #36b8e1
        secondary: '#7F98A5',
        tertiary: '#f1f6f9',
        accent: '#E3EEF4',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
    },
    orange: {
        primary: '#ff5406', // item 2 - #ff5406 ; item 1 - #36b8e1
        secondary: '#7F98A5',
        tertiary: '#ffeddb',
        accent: '#ffb28f',
        anchor: '#ffb28f',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
    },
    teal: {
        primary: '#188D83', // item 2 - #ff5406 ; item 1 - #36b8e1
        secondary: '#126698',
        tertiary: '#d2e0eb',
        accent: '#171E66',
        anchor: '#171E66',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
    }
}
